import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, TransferState } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
    BaseHeaderController,
    FeatureDetectionService,
    HeaderService,
    NavigationModule,
    NavigationService,
    ScrollStatusService,
    SettingsService,
    TopMenuComponent,
} from '@ncg/ui';
import { IconSpriteModule } from 'ng-svg-icon-sprite';

@Component({
    selector: 'ncg-header',
    template: `
        <div class="header__backdrop" [ngClass]="{ 'header__backdrop--is-open': isMegaMenuOverlayVisible }"></div>
        <div class="header__wrapper" #headerWrapper>
            <header #header class="header" [ngClass]="{ 'header--is-sticky': isFixed }">
                <ncg-top-menu class="is-hidden-touch" *ngIf="hasTopMenu" [links]="settings?.topMenuLinks"></ncg-top-menu>
                <div class="header__container">
                    <div class="header__logo">
                        <ng-container *ngIf="settings?.logoLink?.url && settings?.logoLink?.isExternal; else defaultLogo">
                            <a class="logo" aria-label="BYD logo" [href]="settings?.logoLink?.url" [attr.target]="settings?.logoLink?.target">
                                <ng-container *ngTemplateOutlet="logoSymbolTmpl"></ng-container>
                            </a>
                        </ng-container>

                        <ng-template #defaultLogo>
                            <a class="logo" aria-label="BYD logo" [routerLink]="['/']">
                                <ng-container *ngTemplateOutlet="logoSymbolTmpl"></ng-container>
                            </a>
                        </ng-template>
                    </div>

                    <ncg-main-menu (isMegaMenuVisibleSettings)="onMegaMenuChange($event)" class="header__main-menu is-hidden-touch"></ncg-main-menu>

                    <ncg-meta-menu class="header__meta-menu is-hidden-touch"></ncg-meta-menu>

                    <div class="header__mobile-menu is-hidden-desktop">
                        <button ncgMobileMenuTrigger type="button" class="button is-clean is-block" aria-label="menu" aria-expanded="false">
                            <div class="mobile-icon">
                                <svg-icon-sprite
                                    src="nav"
                                    [viewBox]="'0 0 30 30'"
                                    [width]="'30px'"
                                    [height]="'30px'"
                                    aria-hidden="true"></svg-icon-sprite>
                            </div>
                        </button>
                    </div>
                </div>
            </header>
        </div>

        <ng-template #logoSymbolTmpl>
            <svg-icon-sprite src="byd-logo" [viewBox]="'0 0 94 18'" aria-hidden="true"></svg-icon-sprite>
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconSpriteModule, NavigationModule, NgClass, NgIf, NgTemplateOutlet, RouterLink, TopMenuComponent],
})
export class HeaderComponent extends BaseHeaderController {
    constructor(
        cd: ChangeDetectorRef,
        transferState: TransferState,
        headerService: HeaderService,
        scrollStatusService: ScrollStatusService,
        featureDetection: FeatureDetectionService,
        settingsService: SettingsService,
        navigationService: NavigationService
    ) {
        super(cd, transferState, headerService, scrollStatusService, featureDetection, settingsService, navigationService, false);
    }
}
